import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=4f8ec8ed&scoped=true&"
import script from "./CategoryModal.vue?vue&type=script&lang=js&"
export * from "./CategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoryModal.vue?vue&type=style&index=0&id=4f8ec8ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ec8ed",
  null
  
)

component.options.__file = "CategoryModal.vue"
export default component.exports